import { isProduction } from "../utils/env.utils";

export const API_BASE_URL = isProduction() ? 'https://api.koktajlove.pl/v1/calculator' : 'http://localhost:3010/v1/calculator';